import React from 'react';
import './HeaderBar.css';
import { Button } from 'antd';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaUser, FaUserPlus, FaSignOutAlt, FaSignInAlt } from 'react-icons/fa';

const HeaderBar = ({ loggedInUser, handleLogout, openAuthModal }) => {
  return (
    <div className="header-bar">
      <div className="social-links">
        <span>Follow us on:</span>
  <a href="https://www.facebook.com/profile.php?id=61579697636205" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
          <FaFacebook />
        </a>
        <a href="https://www.instagram.com/booklocalindia" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
          <FaInstagram />
        </a>
        <a href="https://www.youtube.com/@BookLocal" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
          <FaYoutube />
        </a>
      </div>
      <div className="user-links">
        {loggedInUser ? (
          <>
            <a href="/account" className="account-link">
              <FaUser /> My Account
            </a>
            <span className="link-separator">|</span>
            <Button type="link" onClick={handleLogout} className="logout-button" icon={<FaSignOutAlt />}>
               Logout
            </Button>
          </>
        ) : (
          <Button type="primary" onClick={openAuthModal} className="login-signup-button" icon={<FaSignInAlt />}>
            Login / Sign Up
          </Button>
        )}
      </div>
    </div>
  );
};

export default HeaderBar;